(function () {
	'use strict';
	MxGridObjectPickerCtrl.$inject = ['uiGridEditConstants', '$scope', '$element', '$timeout'];

	function MxGridObjectPickerCtrl(uiGridEditConstants, $scope, $element, $timeout) {
		var vm = this;
		var selectedItem = null;

		vm.$onInit = function () {
			var colDef = vm.col.colDef;

			vm.model = vm.row.entity.getEntityValue(colDef.field);

			Object.defineProperty(vm, 'selectedItem', {
				get: function () {
					return selectedItem;
				},
				set: setSelectedItem,
			});

			function setSelectedItem(item) {
				selectedItem = item;

				if (!vm.selectedItem) {
					vm.row.entity.setEntityValue(colDef.field, null, '');
				} else {
					if (selectedItem.Id && selectedItem.DisplayString && selectedItem.Id !== vm.row.entity.getEntityValue(colDef.field)) {
						vm.row.entity.setEntityValue(colDef.field, selectedItem.Id, selectedItem.DisplayString);
					}
				}

				$element.find('input').focus();
			}

			vm.onBlur = function ($event) {
				// if click on buttons inside picker (clear or browse) then don't stop editing
				if ($event.relatedTarget && ($event.relatedTarget.classList.contains('autocomplete-search') || $event.relatedTarget.classList.contains('clear-autocomplete'))) {
					return;
				}
				$timeout(function () {
					$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
				});
			};
		};

		$scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
			$timeout(function () {
				$element.find('input').focus();
			});
		});

		return vm;
	}

	/**
	 * @ngdoc directive
	 * @name mx.SolutionBuilderAgent:mxGridObjectPicker
	 * @module mx.SolutionBuilderAgent
	 * @restrict 'E'
	 * @description
	 * The mx-grid-object-picker control is used ......
	 *
	 * @usage <mx-grid-object-picker data-col="col" data-row="row"></mx-grid-object-picker>
	 */
	angular.module('mx.SolutionBuilderAgent').directive('mxGridObjectPicker', [
		function mxGridObjectPickerDirective() {
			return {
				scope: {},
				restrict: 'E',
				bindToController: {
					col: '<',
					row: '<',
				},
				controller: MxGridObjectPickerCtrl,
				controllerAs: 'vm',
				template: [
					function () {
						return (
							'' +
							'<mx-object-picker ' +
							'ng-model="vm.model" ' +
							'entity-class-name="{{::vm.col.colDef.item.ReferenceTo}}" ' +
							'data-on-blur="vm.onBlur" ' +
							'selected-item="vm.selectedItem" ' +
							'ng-class="\'colt\' + vm.col.uid" ' +
							'data-on-blur="vm.onBlur" ' +
							'aria-invalid="false"></mx-object-picker>' +
							''
						);
					},
				],
			};
		},
	]);
})();
